import router from '@/router/'
import store from '@/store/'
import Layout from './Layout.vue'

let modalInstance = null
let callback = null

const DrawerPlugin = {
  install(Vue) {
    Vue.prototype.$Drawer = {
      instance: null,
      callback: null,
      init(config = {}, vueInstance) {
        // If an instance of the modal already exists, return without creating a new one.
        if (modalInstance) {
          return
        }

        // If a callback is provided, we store it.
        if (config.callback && typeof config.callback === 'function') {
          callback = config.callback
        }

        // Create and mount the modal instance.
        const ComponentClass = Vue.extend(Layout)
        modalInstance = new ComponentClass({
          propsData: config.propsData,
          router: router,
          store: store,
          destroyed: () => {
            modalInstance = null
          },
        })

        modalInstance.$mount()
        document.body.appendChild(modalInstance.$el)

        this.instance = modalInstance

        modalInstance.$on('drawer:close', function (payload) {
          if (typeof callback === 'function') {
            callback(payload, vueInstance)
          }
        })
        modalInstance.$on('drawer:open', function (payload) {
          if (typeof callback === 'function') {
            callback(payload, vueInstance)
          }
        })
      },
      destroy() {
        if (modalInstance && modalInstance.$el) {
          if (modalInstance?.$el) {
            modalInstance?.$el.remove()
          }
          modalInstance.$destroy()
        }
      },
    }

    router.afterEach(() => {
      if (modalInstance) {
        modalInstance.isOpen = false
      }
    })
  },
}

export default DrawerPlugin
